import { ActivityQueryFiltersDto, FindAllTicketsQueryFilters } from "../../api-client";

export const scopes = {
  tickets: "tickets",
  ticketActivities: "ticketActivities",
  ticketById: "ticketById",
  ticketFilters: "ticketFilters",
  expiredTickets: "expiredTickets",
  ticketsByDate: "ticketsByDate",
};

export const ticketKeys = {
  tickets: {
    scope: scopes.tickets,
    all: () => [scopes.tickets] as const,
    filtered: (filters: FindAllTicketsQueryFilters) => [scopes.tickets, filters] as const,
  },
  ticketById: {
    scope: scopes.ticketById,
    all: (ticketId: number) => [scopes.ticketById, { ticketId }] as const,
  },

  ticketFilters: {
    scope: scopes.ticketFilters,
    all: () => [scopes.ticketFilters] as const,
    flatAll: () => [scopes.ticketFilters, "flat"] as const,
  },
  activities: {
    scope: scopes.ticketActivities,
    all: () => [scopes.ticketActivities] as const,
    byTicket: (ticketId: number) => [scopes.ticketActivities, "byTicket", { ticketId }] as const,
    byTicketFiltered: (ticketId: number, filters: ActivityQueryFiltersDto) =>
      [scopes.ticketActivities, "byTicket", { ticketId }, filters] as const,
    filtered: (filters: ActivityQueryFiltersDto) => [scopes.ticketActivities, filters] as const,
  },
  expiredTickets: {
    scope: scopes.expiredTickets,
    all: () => [scopes.expiredTickets] as const,
    byDigestType: (digestType?: string, userId?: string, locationId?: string) => 
      [scopes.expiredTickets, { digestType, userId, locationId }] as const,
  },
  ticketsByDate: {
    scope: scopes.ticketsByDate,
    all: () => [scopes.ticketsByDate] as const,
    byDate: (date: string) => [scopes.ticketsByDate, { date }] as const,
    byDateAndDigestType: (date: string, digestType?: string, userId?: string, locationId?: string) => 
      [scopes.ticketsByDate, { date, digestType, userId, locationId }] as const,
  },
};
